import { UploadChunkRequest, UploadChunkReply } from './file_transfer_pb';
import {
    decodeUploadChunkReplyFrame,
    encodeUploadChunkRequestFields,
} from './fileTransferProtobufCodec';

// High-performance binary protobuf client - SADECE UPLOAD için
export class FileTransferServiceClient {
    private readonly serviceUrl: string;

    constructor(serviceUrl: string = `${import.meta.env.VITE_STUDIO_URL}`) {
        this.serviceUrl = serviceUrl;
    }

    async uploadChunk(request: UploadChunkRequest, signal?: AbortSignal): Promise<UploadChunkReply> {
        return this.postUploadChunk('filetransfer.FileTransferService/UploadChunk', request, signal, true);
    }

    async uploadRetouchChunk(request: UploadChunkRequest, signal?: AbortSignal): Promise<UploadChunkReply> {
        return this.postUploadChunk('filetransfer.FileTransferService/UploadRetouchChunk', request, signal, false);
    }

    async uploadRetouchBatchChunk(request: UploadChunkRequest, signal?: AbortSignal): Promise<UploadChunkReply> {
        return this.uploadRetouchChunk(request, signal);
    }

    private async postUploadChunk(
        endpoint: string,
        request: UploadChunkRequest,
        signal: AbortSignal | undefined,
        allowParallelIncompleteLastChunk: boolean
    ): Promise<UploadChunkReply> {
        const binaryPayload = this.encodeBinaryProtobuf(request);
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${this.serviceUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/grpc-web+proto',
                Accept: 'application/grpc-web+proto',
                'X-Grpc-Web': '1',
                'grpc-encoding': 'identity',
                'grpc-accept-encoding': 'identity',
                Authorization: `Bearer ${token}`,
            },
            body: binaryPayload,
            signal,
        });

        if (!response.ok) {
            await response.text();
            throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
        }

        const responseBuffer = await response.arrayBuffer();
        const result = decodeUploadChunkReplyFrame(responseBuffer);

        const parallel = allowParallelIncompleteLastChunk && (request.totalChunks ?? 0) > 0;
        if (!parallel && request.isLastChunk && !result.completed) {
            throw new Error(`Upload failed: ${result.message || 'Server returned completed: false'}`);
        }

        return result;
    }

    private encodeBinaryProtobuf(request: UploadChunkRequest): ArrayBuffer {
        const protobufMessage = encodeUploadChunkRequestFields(request);
        const messageLength = protobufMessage.length;

        const frame = new ArrayBuffer(5 + messageLength);
        const view = new DataView(frame);

        view.setUint8(0, 0);
        view.setUint32(1, messageLength, false);

        const frameBytes = new Uint8Array(frame);
        frameBytes.set(protobufMessage, 5);

        return frame;
    }
}
